import React from "react";
import { useTranslation } from "react-i18next";
import { ChevronRight } from "lucide-react";
import { SINGLE_VALUE } from "./constants";
import OutletItem from "./OutletItem";
import { toggleRegion } from "./helpers";

const RegionItem = ({
  region,
  expandedRegions,
  expandedOutlets,
  expandedBranches,
  searchTerm,
  subMenuID,
  setSubMenuID,
  currentOutlets,
  showAllTerminals,
  handleToggleShowAll,
  setCurrentBranch,
  setInfoPopupOpen,
  setExpandedRegions,
  setExpandedOutlets,
  setExpandedBranches,
  outletActions,
  branchActions,
  terminalActions,
}) => {
  const { t: translate } = useTranslation();
  const hasOutlets = !!region.outlets.length;

  return (
    <div key={region.id} className="mb-4 py-4 p-2 rounded">
      <div
        onClick={() =>
          hasOutlets &&
          toggleRegion({
            regionId: region.id,
            setSubMenuID,
            setExpandedRegions,
          })
        }
        className="text-xl font-bold cursor-pointer flex items-center"
      >
        <span
          className={`transform transition-transform duration-500 dark:text-white ${
            expandedRegions[region.id] ? "rotate-90" : "rotate-0"
          }`}
        >
          <ChevronRight size={20} />
        </span>
        <div className="flex gap-2 ml-2 items-baseline">
          <span data-testid={`region-${region.id}`} className="dark:text-white text-gray-900">
            {region.name}
          </span>
          <span className=" text-xs text-gray-400">
            {region.outlets.length} {translate("hierarchy.region")}
            {region.outlets.length > SINGLE_VALUE ? "s" : ""}
          </span>
          <span className="text-primary-500 text-xs">
            {searchTerm !== "" && ` matching "${searchTerm}"`}
          </span>
        </div>
      </div>
      {expandedRegions[region.id] && (
        <div
          className={`ml-[11px] transition-all border-l-2 border-gray-200 duration-500`}
        >
          {currentOutlets.map((outlet) => (
            <OutletItem
              key={outlet.id}
              outlet={outlet}
              region={region}
              expandedRegions={expandedRegions}
              expandedOutlets={expandedOutlets}
              expandedBranches={expandedBranches}
              searchTerm={searchTerm}
              subMenuID={subMenuID}
              setSubMenuID={setSubMenuID}
              showAllTerminals={showAllTerminals}
              handleToggleShowAll={handleToggleShowAll}
              setCurrentBranch={setCurrentBranch}
              setInfoPopupOpen={setInfoPopupOpen}
              setExpandedOutlets={setExpandedOutlets}
              setExpandedBranches={setExpandedBranches}
              outletActions={outletActions}
              branchActions={branchActions}
              terminalActions={terminalActions}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default RegionItem;
